<template>

    <div class="container-fluid">
        <div class="container-fluid">
                <div class="row d-flex justify-content-between">
                <div class="col-8">
                    <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    <br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>

                </div>
                <div class="col-4"> 
                  <!-- {{ patient }} -->
                    <img class="img-rounded" src="@/assets/images/sick.png" height="40px" /><br>
                    
                    <!-- <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black"> -->
                    <!-- <table v-for="item in patient" :key="item.id" class="table" density="compact" style="color:black" > 

                   <tr><td>Full Name</td><td> {{ item.name }}</td></tr>
                    <tr><td>Gender</td><td> {{ item.gender }} </td></tr>
                    <tr><td> Telephone </td><td> {{ item.telephone }} </td></tr>
                    <tr><td> Date of Birth </td><td> {{ item.date_of_birth }} </td></tr>
                    <tr><td> Address </td><td> {{ item.address }} </td></tr>
                  
                    </table> -->
                    <table  class="table" density="compact" style="color:black" > 

                      <tr><td>Full Name</td><td> {{ patient.name }}</td></tr>
                      <tr><td>Gender</td><td> {{ patient.gender }} </td></tr>
                      <tr><td> Telephone </td><td> {{ patient.telephone }} </td></tr>
                      <tr><td> Date of Birth </td><td> {{ patient.date_of_birth }} </td></tr>
                      <tr><td> Address </td><td> {{ patient.address }} </td></tr>

                      </table>
                 
                    <h5 class="my-3"><i class="mdi mdi-calendar">Visit date</i> &nbsp;&nbsp; {{ visit_date }}</h5>
                </div> 
          
            </div>
        </div>
        <div class="px-0 shadow">
              <div class="card-header ">
                <h4 class="mt-2 text-center text-decoration-underline">Discharge Information</h4>
              </div>
              <div class="card-body ">
                <div v-show="date_of_admission !== null">
                <b>Date of Admission</b> <br>
                <span v-html="date_of_admission" style="line-height: 10px;"></span><br><br>
              </div>
              <div v-show="medical_summary !== null">
                <b class=" text-center">Medical Summary</b> <br>
                <span v-html="medical_summary" style="line-height: 10px;"></span><br><br>
              </div>
              <div v-show="diagnosis !== null">
                <b class=" text-center">Diagnosis</b> <br>
                <span v-html="diagnosis" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="investigation_done !== null">
                <b class=" text-center">Investigation Done</b> <br>
                <span v-html="investigation_done" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="treatment_given !== null">
                <b class=" text-center">Treatment Given</b> <br>
                <span v-html="treatment_given" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="treatment_discharge !== null">
                <b class=" text-center">Treatment On Discharge</b> <br>
                <span v-html="treatment_discharge" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="discharge_notes !== null">
                <b class=" text-center">Discharge Notes</b> <br>
                <span v-html="discharge_notes" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="discharge_date !== null">
                <b>Date</b><br>
                <span v-html="discharge_date" style="line-height: 10px;"></span><br><br>
               </div>
               <div v-show="follow_up_date !== null">
                <b>Follow up</b> <br>
                <span v-html="follow_up_date" style="line-height: 10px;"></span><br><br>
               </div>
              </div>
              
              
                {{ date }}
              <div class="card-footer  ">
                <div class="mt-3 text-center">
                  <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                  <p style="color:black;font-size:13px">Printed by : {{ userData.username }} <br>  Via Afrimed Software | www.afrimed.com </p>
                </div>
              </div>
          </div>
        </div>
      </template>
      
      <script>
      import axios from "axios";
      export default {
        data() {
          return {
            patientspinner:true,
            dischargespinner:true,
            userData: JSON.parse(localStorage.getItem("user")),
            id:'',
            discharge_notes:'',
            discharge_date:new Date().toLocaleDateString('fr-CA'),
            follow_up_date:'',
            visit_date:"",
            date_of_admission:'',
            medical_summary:'',
            diagnosis:'',
            investigation_done:'',
            treatment_discharge:'',
            treatment_given:'',
            date:'',
            patientid:'',
            patient_id:'',
            discharges:[],
            patients:[],
            // patient:[],
            patient:'',
            
                                 
          };
        },
        created() {
         this.fetchInfo();
         this.showdischarge();
       
    
        },
        mounted() {
           
        setTimeout(() => {
            window.print();
            window.onafterprint=this.$router.go(-1);
        }, 5800);
        } ,
        methods: {
         getFiles(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"logos/"+name;
            return imagelink;
          },
          async fetchInfo(){
            this.id=this.$route.query.id;
            let url = `/visitinfo/${this.id}`;
            await axios.get(url).then((response) => {
              this.patient = response.data.visits[0].patient;
              this.showdischarge();
            });
          },
          // async showpatient(){
          //   this.patientid=this.$route.query.patient_id;

          //   let url = `/patientprofile/${this.patientid}`;
          //   await axios.get(url).then((response) => {
             
          //     this.patients = response.data.patients;
          //     this.patientspinner=false;
             

          //   });
          // },
    
    async showdischarge(){
            this.id=this.$route.query.id;
            let url = `/printdischarge/${this.id}`;
            await axios.get(url).then((response) => {
              // this.patients = response.data.patients;
              // this.patientspinner=false;        
           
            if (response.data.discharges.length===0) {
              this.patient = '';
              this.discharge_date = '';
              this.discharge_notes = '';
              this.follow_up_date = '';
              this.date_of_admission ='';
              this.medical_summary='';
              this.diagnosis='';
              this.investigation_done='';
              this.treatment_discharge='';
              this.treatment_given='';
              
            }else{
              this.patient = response.data.discharges[0].patient;
              this.discharge_date = response.data.discharges[0].discharge_date;
              this.discharge_notes = response.data.discharges[0].discharge_notes;
              this.follow_up_date = response.data.discharges[0].follow_up_date;
              this.date_of_admission = response.data.discharges[0].date_of_admission;
              this.diagnosis = response.data.discharges[0].diagnosis;
              this.medical_summary = response.data.discharges[0].medical_summary;
              this.investigation_done = response.data.discharges[0].investigation_done;
              this.treatment_discharge = response.data.discharges[0].treatment_discharge;
              this.treatment_given = response.data.discharges[0].treatment_given;
              this.date = response.data.discharges[0].created_at;
            }
            });
          },
          
          
        },
      };
      </script>